import { Fragment } from 'react'
import Head from 'next/head'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

type MetaTag = {
  content: string | null
  name: string | null
  property: string | null
}

type SiteSeoProps = {
  faviconLink: string
  metaTags: Array<MetaTag>
}

const SiteSEO = ({ faviconLink, metaTags }: SiteSeoProps) => {
  const { NODE_ENV } = publicRuntimeConfig
  return (
    <Head>
      {NODE_ENV !== 'production' && <meta name='robots' content='noindex,nofollow' />}
      <link href={faviconLink} rel='shortcut icon' />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || []
                function gtag(){ dataLayer.push(arguments) }
            `,
        }}
      />
      {metaTags.map(({ content, property, name }, index) => (
        <Fragment key={index}>
          {name && <meta content={content || ''} name={name} key={name} />}
          {property && <meta content={content || ''} property={property} key={property} />}
        </Fragment>
      ))}
    </Head>
  )
}

export default SiteSEO
